import { useNavigate } from "react-router-dom"

import { DropdownMenu } from "@/components/DropdownMenu"
import { ROUTES_CONFIG } from "@/constants"
import { isMobileDevice } from "@/utils"

enum InstrumentType {
  FX = "FX",
  CREDIT = "Credit",
  EQUITIES = "Equities",
}

export const InstrumentDropdown = () => {
  const navigate = useNavigate()

  const routeMap = {
    [InstrumentType.FX]: "/",
    [InstrumentType.CREDIT]: ROUTES_CONFIG.credit,
    [InstrumentType.EQUITIES]: ROUTES_CONFIG.equities,
  }

  const handleInstrumentTypeSelection = (instrumentType: InstrumentType) => {
    navigate(routeMap[instrumentType])
  }

  const getSelectedInstrument = (pathName: string) => {
    if (pathName.includes("equities")) {
      return InstrumentType.EQUITIES
    }
    if (pathName.includes("credit")) {
      return InstrumentType.CREDIT
    }
    return InstrumentType.FX
  }

  const instruments = Object.values(InstrumentType).filter(
    (instrument) => !isMobileDevice || instrument !== InstrumentType.CREDIT,
  )

  return (
    <DropdownMenu
      className="mr-auto"
      options={instruments}
      onSelectionChange={(selection) => {
        handleInstrumentTypeSelection(selection)
      }}
      selectedOption={getSelectedInstrument(location.pathname)}
    />
  )
}
